<template>
  <v-navigation-drawer
    app
    class="app--drawer"
    :mini-variant.sync="mini"
    v-model="drawer"
    :width="drawWidth"
    :dark="$vuetify.dark"
  >
    <v-toolbar color="primary">
      <img :src="computeLogo" height="50" alt="Transit Web Template" />
    </v-toolbar>
    <vue-perfect-scrollbar
      class="drawer-menu--scroll"
      :settings="scrollSettings"
    >
      <v-list expand dense v-if="items">
        <template v-for="(item, i) in items">
          <template v-if="item.roles && item.roles.includes(currentRole)">
            <v-subheader
              v-if="item.header"
              :key="`subheader-${i}`"
              v-text="item.header"
            />
            <v-divider v-else-if="item.divider" :key="`divider-${i}`" />
            <list-group
              v-else-if="item.group"
              :key="`group-${i}`"
              :item="item"
            />
            <list-item
              v-else
              :key="`item-${i}`"
              :icon="item.icon"
              :subtext="item.subtext"
              :text="item.text"
              :to="item.to"
            />
          </template>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import menu from '@/menu'
import SessionHelper from '@/helpers/SessionHelper'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ListGroup from '@/components/List/Group'
import ListItem from '@/components/List/Item'
export default {
  name: 'AppDrawer',
  components: {
    VuePerfectScrollbar,
    ListGroup,
    ListItem,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
    drawWidth: {
      type: [Number, String],
      default: '260',
    },
    showDrawer: {
      immediate: true,
    },
  },
  data() {
    return {
      mini: false,
      items: menu,
      drawer: true,
      scrollSettings: {
        maxScrollbarLength: 160,
      },
    }
  },

  computed: {
    computeGroupActive() {
      return true
    },
    computeLogo() {
      return '/static/transit_logo_menu.png'
    },
    currentRole() {
      return SessionHelper.role
    },
  },
  watch: {
    showDrawer: {
      handler(val) {
        this.drawer = val
      },
      immediate: true,
    },
  },
  created() {},

  methods: {
    genChildTarget(item, subItem) {
      if (subItem.href) return
      if (subItem.component) {
        return {
          name: subItem.component,
        }
      }
      return { name: `${item.group}/${subItem.name}` }
    },
  },
}
</script>

<style lang="stylus" scoped>
.app--drawer
  overflow: hidden

  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto
</style>
